export default __webpack_public_path__ + "static/media/gallery-wip-crystal-holder_08.fef7b8e4.jpg";